import { fishJackpotType } from "./type";

const initialAuthState = {
  fishJackpotList: null,
  isLoading: false,
  statusCode: null
};

export const reducer = (state = initialAuthState, action) => {
  switch (action.type) {
    case fishJackpotType.GET_FISH_JACKPOT_LIST_REQUEST:
      return { ...state, isLoading: true };
    case fishJackpotType.GET_FISH_JACKPOT_LIST_SUCCESS:
      return { ...state, isLoading: false, fishJackpotList: action.payload.data };
    case fishJackpotType.GET_FISH_JACKPOT_LIST_FAIL:
      return { ...state, isLoading: false, error: action.error };
    default:
      return state;
  }
};
